import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Nazwa zlecenia druku',
      placeholder: 'Ulotka A5 - promocja specjalna',
    },
    format: {
      label: 'Typ produktu',
      placeholder: 'Wybierz typ produktu',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Ulotka (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Ulotka (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Naklejka (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Naklejka na drzwi (30x30cm)',
      },
    },
    file: {
      label: 'Plik',
    },
  },
  buttons: {
    upload: 'Kliknij lub przeciągnij, aby przesłać plik',
    save: 'Zapisz',
  },
  toasts: {
    changes_got_saved: 'Zmiany zostały zapisane!',
  },
};
